export default {
	loading: 'Inhalt wird geladen...',
	error: 'Fehler beim Laden der Inhalte.',
	notFound: 'Keine Inhalte gefunden.'
}
